import { FeedbackCategoryResource, FeedbackResource } from '@/models'
import {
    FEEDBACK_CATEGORIES_FAILURE,
    FEEDBACK_CATEGORIES_SUCCESS,
    FEEDBACK_FAILURE,
    FEEDBACK_REQUEST,
    FEEDBACK_SUBMIT,
    FEEDBACK_SUBMIT_FAILURE,
    FEEDBACK_SUBMIT_SUCCESS,
    FEEDBACK_SUCCESS,
} from '@/redux/actionTypes'

export interface FeedbackState {
    feedback: FeedbackResource | null
    categories: FeedbackCategoryResource[]
    name: string
    date: string
    loading: boolean
    sendingData: boolean
    dataSubmitSuccess: boolean
    dataSubmitFailure: boolean
    failure: boolean
    errors: unknown
}

export type FeedbackAction =
    | { type: typeof FEEDBACK_REQUEST }
    | { type: typeof FEEDBACK_SUCCESS, name: string, date: string }
    | { type: typeof FEEDBACK_CATEGORIES_SUCCESS, data: FeedbackCategoryResource[] }
    | { type: typeof FEEDBACK_CATEGORIES_FAILURE | typeof FEEDBACK_FAILURE, errors: unknown }
    | { type: typeof FEEDBACK_SUBMIT }
    | { type: typeof FEEDBACK_SUBMIT_SUCCESS }
    | { type: typeof FEEDBACK_SUBMIT_FAILURE, errors?: unknown }

const initialState: FeedbackState = {
    feedback: null,
    categories: [],
    name: '',
    date: '',
    loading: true,
    sendingData: false,
    dataSubmitSuccess: false,
    dataSubmitFailure: false,
    failure: false,
    errors: [],
}

export const feedbackReducer = (state: FeedbackState = initialState, action: FeedbackAction): FeedbackState => {
    switch (action.type) {
        case FEEDBACK_REQUEST:
            return { ...state, loading: true }
        case FEEDBACK_SUCCESS:
            return {
                ...state,
                loading: false,
                name: action.name,
                date: action.date,
            }
        case FEEDBACK_CATEGORIES_SUCCESS:
            return {
                ...state,
                loading: false,
                categories: action.data,
            }
        case FEEDBACK_CATEGORIES_FAILURE:
            return {
                ...state, loading: false, errors: action.errors, failure: true,
            }
        case FEEDBACK_FAILURE:
            return {
                ...state, loading: false, errors: action.errors, failure: true,
            }
        case FEEDBACK_SUBMIT:
            return {
                ...state, sendingData: true,
            }
        case FEEDBACK_SUBMIT_SUCCESS:
            return {
                ...state, dataSubmitSuccess: true,
            }
        case FEEDBACK_SUBMIT_FAILURE:
            return {
                ...state, dataSubmitFailure: true,
            }
        default:
            return state
    }
}
